// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobileCutomPaddingNotif .b-dropdown-text[data-v-b4d2839c]{padding:0!important}.v-app-bar.v-app-bar--is-scrolled[data-v-b4d2839c] :deep(.v-toolbar__image){opacity:1}.v-app-bar[data-v-b4d2839c] :deep(.v-toolbar__image){-webkit-transition:opacity .15s ease-in;transition:opacity .15s ease-in;opacity:0}.app-bar-img[data-v-b4d2839c] .v-responsive__content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);
// Exports
module.exports = exports;
